import { ReactElement } from "react";

import { Tooltip, TooltipContent, TooltipTrigger } from "@fronterahealth/frontera-ui-components/ui/tooltip";

interface CommentActionTooltipProps {
  label: string;
  children: ReactElement;
}

export const CommentActionTooltip: React.FC<CommentActionTooltipProps> = ({ label, children }) => (
  <Tooltip>
    <TooltipTrigger render={children} delay={600} />
    <TooltipContent>{label}</TooltipContent>
  </Tooltip>
);
